import { useGretaAIChatContext } from '../../GretaAIChat.hooks'
import { getGretaAIChatSuggestedPrompts } from '../../GretaAIChat.utils.sourceTexts'
import { GretaAIChatLockedState } from '../../GretaAIChatLockedState'
import { GretaAIChatMessageList } from '../../GretaAIChatMessageList'

function GretaAIChatPanelFeed({ inputRef }) {
  const { actions, conversation, panel, source } = useGretaAIChatContext()

  const { activeChatId, isLimitReached, isLocked } = panel

  const {
    displayName,
    feedbackByMessageId,
    messages,
    pendingAnswerFileName,
    status,
    turnStartedAt,
    onLoadOlderMessages,
    onReloadMessages,
  } = conversation

  const { setDraft, onRetry, onSendMessage, onSubmitFeedback } = actions

  const {
    askElsewhereTarget,
    isSourceChoiceEnabled,
    source: chatSource,
    onAskElsewhere,
  } = source

  const suggestedPrompts = getGretaAIChatSuggestedPrompts({
    isSourceChoiceEnabled,
    source: chatSource,
  })

  function handleSelectPrompt(text) {
    setDraft(text)
    inputRef.current?.focus()
  }

  function handleAskElsewhere() {
    onAskElsewhere()
    inputRef.current?.focus()
  }

  return isLocked ? (
    <GretaAIChatLockedState />
  ) : (
    <GretaAIChatMessageList
      askElsewhereTarget={askElsewhereTarget}
      displayName={displayName}
      feedbackByMessageId={feedbackByMessageId}
      isLimitReached={isLimitReached}
      isNewChat={activeChatId === null}
      messages={messages}
      pendingAnswerFileName={pendingAnswerFileName}
      status={status}
      suggestedPrompts={suggestedPrompts}
      turnStartedAt={turnStartedAt}
      onAskElsewhere={handleAskElsewhere}
      onLoadOlderMessages={onLoadOlderMessages}
      onReloadMessages={onReloadMessages}
      onRetry={onRetry}
      onSelectPrompt={handleSelectPrompt}
      onSendPrompt={onSendMessage}
      onSubmitFeedback={onSubmitFeedback}
    />
  )
}

export default GretaAIChatPanelFeed
